import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Link } from '@rocketlane/rocket-router';
import { Space, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Breadcrumb } from 'components/atoms/breadcrumb';
import { IconShell } from 'components/atoms/icon-shell';
import { Header } from 'components/molecules/page/header';
import { ProductiveHeading05 } from 'components/styles';
const { Title } = Typography;
const HeaderTitle = styled(Title)`
  ${ProductiveHeading05};
  margin-bottom: 0px;
`;
const StyledHeader = styled(Header)`
  padding-bottom: ${(props)=>props.withBottomPadding ? 'var(--spacing-02) !important' : '0'};
`;
const DummyLink = styled(Link)`
  pointer-events: none;
`;
export const IntegrationHeader = ({ title, icon, subText, tabs, breadcrumbLink, breadcrumbText, learnMoreLink, disableBreadcrumb })=>{
    const breadcrumbTextWithPlaceholder = breadcrumbText !== null && breadcrumbText !== void 0 ? breadcrumbText : /*#__PURE__*/ _jsx(FormattedMessage, {
        id: "integrations"
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(StyledHeader, {
                withBottomPadding: !tabs,
                breadcrumbs: /*#__PURE__*/ _jsx(Breadcrumb.Item, {
                    children: disableBreadcrumb ? /*#__PURE__*/ _jsx(DummyLink, {
                        to: "/settings/integrations",
                        "data-cy": "settings.integrations",
                        children: breadcrumbTextWithPlaceholder
                    }) : /*#__PURE__*/ _jsx(Link, {
                        to: breadcrumbLink !== null && breadcrumbLink !== void 0 ? breadcrumbLink : '/settings/integrations',
                        "data-cy": "settings.integrations",
                        children: breadcrumbTextWithPlaceholder
                    })
                }),
                title: /*#__PURE__*/ _jsxs(Space, {
                    align: "center",
                    children: [
                        icon ? /*#__PURE__*/ _jsx(IconShell, {
                            icon: icon,
                            size: "small"
                        }) : null,
                        /*#__PURE__*/ _jsx(HeaderTitle, {
                            "data-cy": "integrations.title",
                            level: 4,
                            children: title
                        })
                    ]
                }),
                subText: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        subText,
                        " ",
                        learnMoreLink
                    ]
                }),
                tabs: tabs,
                sticky: true
            }),
            /*#__PURE__*/ _jsx(Helmet, {
                children: /*#__PURE__*/ _jsx("title", {
                    children: title
                })
            })
        ]
    });
};
